import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getColor, type Theme } from 'styles/theme';

export const HeroWrapper = styled.div<{ theme: Theme }>`
  border: 1px solid ${getColor('borderTertiary')};
  background-image: linear-gradient(to right, white 40% , ${getColor('borderGold')} 130%);
  padding: 16px 16px 0 16px;
  min-width: 300px;
  position: relative;

  .check-svg {
    position: absolute;
    height: 24px;
    width: 24px;
    top: -12px;
    left: -12px;
  }

  @media (${breakpoint.mdMin}) {
    display: flex; 
    justify-content: space-between;
    padding: 24px 0 0 24px;
    min-width: 450px;

    .check-svg, .checkmark {
      width: 32px;
      height: 32px;
      top: -14px;
      left: -14px;
    }
  }

`;

export const ContentWrapper = styled.div`
  @media (${breakpoint.mdMin}) {
    max-width: 296px;
  }

  @media (${breakpoint.xxlMin}) {
    max-width: 228px;
  }
`;

export const NewsletterFrequency = styled.div`
  font-family: ${font.graphikCond};
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;

  @media (${breakpoint.mdMin}) {
    font-size: 20px;
    line-height: 30px;
  }
`;

export const HeroTitle = styled.div<{ theme: Theme }>`
  font-family: ${font.graphikCond};
  color: ${getColor('textPrimary')};
  font-size: 24px;
  font-weight: 600;
  line-height: 29px;
  letter-spacing: 0.5px;
  margin-bottom: 8px;

  @media (${breakpoint.mdMin}) {
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 16px;
    min-height: 76px;
}
`;

export const HeroDescription = styled.div`
  font-family: ${font.graphikCond};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  overflow: hidden;
  min-height: 96px;

  @media (${breakpoint.mdMin}) {
    min-height: 76px;
  }

  p {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;

    @media (${breakpoint.mdMin}) {
      -webkit-line-clamp: 5;
    }
  }

  @media (${breakpoint.mdMin}) {
    margin-right: 0;
    margin-bottom: 16px;
    line-height: 19px;
  }
`;

export const SubscribeSection = styled.div<{ theme: Theme; hasSampleUrl: boolean }>`
  display: flex;
  justify-content: ${(props) => (props.hasSampleUrl ? 'space-between' : 'right')};
  align-items: center;
  margin-bottom: 8px;

  .sub-button {
    height: 32px;

    &:hover {
      .svg-path {
        fill: ${getColor('textLink')};
      } 
    }
  }

  @media (${breakpoint.mdMin}) {
    margin-right: 0;
    margin-bottom: 24px;
  }
`;

export const ImageWrapper = styled.img`
  width: 198px;
  height: 158px;
  margin-left: auto;

  @media (${breakpoint.mdMin}) {
    margin-top: auto;
    width: 218px;
    height: 172px;
  }

  @media (${breakpoint.xxlMin}) {
    width: 268px;
    height: 214px;
  }
`;
